import CustomCampaignFloatingFilter from "./customCampaignFloatingFilter";

export const defaultColDef = {
    flex: 5,
    filter: false,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    minWidth: 150,
    floatingFilter: false,
    suppressHeaderMenuButton: true,
};
export const campaignColumnDefs = [
    {
        headerName: "SYNTHETIC ID",
        field: "synthetic_id",
        resizable: true,
        minWidth: 120,
        wrapText: true,
        autoHeight: true,
        flex: 1,
        filter: false,
        floatingFilter: false,
        floatingFilterComponent: CustomCampaignFloatingFilter,
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "DATE RANGE",
        field: "dateRange",
        resizable: true,
        minWidth: 200,
        wrapText: true,
        autoHeight: true,
        flex: 5,
        suppressHeaderMenuButton: true,
        cellEditor: 'agDateCellEditor',
        editable: false,
        filter: true,
        floatingFilter: false,
        floatingFilterComponent: CustomCampaignFloatingFilter,
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "CHANNELS",
        field: "channels",
        minWidth: 225,
        wrapText: true,
        autoHeight: true,
        resizable: true,
        flex: 3,
        suppressHeaderMenuButton: true,
        valueFormatter: (params) => {
            if (!params.value) {
                return "";
            }
            let channelNameString = '';
            params.value.forEach((channel) => {
                channelNameString += channel.channel_name + ', ';
            });
            channelNameString = channelNameString.slice(0, -2);
            return channelNameString;
        },
        sortable: false,
        filter: false,
        floatingFilter: false,
        floatingFilterComponent: CustomCampaignFloatingFilter,
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "SUPPLIERS",
        field: "channels",
        minWidth: 400,
        wrapText: true,
        autoHeight: true,
        resizable: true,
        flex: 4,
        suppressHeaderMenuButton: true,
        hide: true,
        valueFormatter: (params) => {
            if (!params.value) {
                return "";
            }            

            // Extract publisher display names, excluding ad verification and ad server types
            const supplierNames = params.value
                .flatMap(channel => channel.publishers)
                .filter(publisher => {
                    const publisherType = publisher?.publisher_type?.toLowerCase();
                    return !['ad verification', 'ad server'].includes(publisherType);
                })
                .map(publisher => publisher?.publisher_display_name)
                .filter(Boolean); // Remove any undefined/null values

            // Get unique names (case-insensitive) and format with proper capitalization
            const uniqueSuppliers = [...new Set(supplierNames.map(name => name.toLowerCase()))]
                .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase());

            return uniqueSuppliers.join(', ');
        },
        sortable: false,
        filter: false,
        floatingFilter: false,
        floatingFilterComponent: CustomCampaignFloatingFilter,
        suppressFloatingFilterButton: false,
    },
    {
        headerName: "PLANNED",
        children: [
            {
                headerName: "NET MEDIA + FEES",
                field: "planned_budget",
                resizable: true,
                wrapText: true,
                autoHeight: true,
                editable: false,
                cellEditor: "agNumberCellEditor",
                flex: 1,
                suppressHeaderMenuButton: true,
                sortable: false,
                filter: false,
                floatingFilter: false,
                floatingFilterComponent: CustomCampaignFloatingFilter,
                suppressFloatingFilterButton: false,
            },
            {
                headerName: "NET MEDIA",
                field: "planned_netmedia",
                resizable: true,
                hide: true,
                wrapText: true,
                autoHeight: true,
                editable: false,
                cellEditor: "agNumberCellEditor",
                flex: 1,
                suppressHeaderMenuButton: true,
                sortable: false,
                filter: false,
                floatingFilter: false,
                floatingFilterComponent: CustomCampaignFloatingFilter,
                suppressFloatingFilterButton: false,
            },
            {
                headerName: "FEES",
                field: "planned_fees",
                resizable: true,
                hide: true,
                wrapText: true,
                autoHeight: true,
                editable: false,
                cellEditor: "agNumberCellEditor",
                flex: 1,
                suppressHeaderMenuButton: true,
                sortable: false,
                filter: false,
                floatingFilter: false,
                floatingFilterComponent: CustomCampaignFloatingFilter,
                suppressFloatingFilterButton: false,
            },

        ]
    },
    {
        headerName: "ORDERED",
        children: [
            {
                headerName: "NET MEDIA + FEES",
                field: "ordered_budget",
                resizable: true,
                wrapText: true,
                autoHeight: true,
                editable: false,
                cellEditor: "agNumberCellEditor",
                flex: 1,
                suppressHeaderMenuButton: true,
                sortable: false,
                filter: false,
                floatingFilter: false,
                floatingFilterComponent: CustomCampaignFloatingFilter,
                suppressFloatingFilterButton: false,
            },
            {
                headerName: "NET MEDIA",
                field: "ordered_netmedia",
                resizable: true,
                hide: true,
                wrapText: true,
                autoHeight: true,
                editable: false,
                cellEditor: "agNumberCellEditor",
                flex: 1,
                suppressHeaderMenuButton: true,
                sortable: false,
                filter: false,
                floatingFilter: false,
                floatingFilterComponent: CustomCampaignFloatingFilter,
                suppressFloatingFilterButton: false,
            },
            {
                headerName: "FEES",
                field: "ordered_fees",
                resizable: true,
                hide: true,
                wrapText: true,
                autoHeight: true,
                editable: false,
                cellEditor: "agNumberCellEditor",
                flex: 1,
                suppressHeaderMenuButton: true,
                sortable: false,
                filter: false,
                floatingFilter: false,
                floatingFilterComponent: CustomCampaignFloatingFilter,
                suppressFloatingFilterButton: false,
            },

        ]
    },
    {
        headerName: "BILLING CODE",
        hide: true,
        children: [
            {
                headerName: "CLIENT CODE",
                field: "clientid",
                width: 100,
                wrapText: true,
                autoHeight: true,
                resizable: true,
                flex: null,
                suppressHeaderMenuButton: true,
                sortable: false,
                filter: false,
                floatingFilter: false,
                floatingFilterComponent: CustomCampaignFloatingFilter,
                suppressFloatingFilterButton: false,
                hide: true,
                valueFormatter: (params) => {
                    if (!params.value) {
                        return ""; // Return an empty string if no value
                    }
                    if (Array.isArray(params.value)) {
                        return params.value.join(", "); // Join array elements with a comma
                    }
                    return params.value.toString(); // Convert to string if it's a single value
                },
            },
            {
                headerName: "PRODUCT CODE",
                field: "productid",
                width: 100,
                wrapText: true,
                autoHeight: true,
                resizable: true,
                flex: null,
                suppressHeaderMenuButton: true,
                sortable: false,
                filter: false,
                floatingFilter: false,
                floatingFilterComponent: CustomCampaignFloatingFilter,
                suppressFloatingFilterButton: false,
                hide: true,
                valueFormatter: (params) => {
                    if (!params.value) {
                        return ""; // Return an empty string if no value
                    }
                    if (Array.isArray(params.value)) {
                        return params.value.join(", "); // Join array elements with a comma
                    }
                    return params.value.toString(); // Convert to string if it's a single value
                },
            },
            {
                headerName: "ESTIMATE",
                field: "estimateid",
                width: 100,
                wrapText: true,
                autoHeight: true,
                resizable: true,
                flex: null,
                suppressHeaderMenuButton: true,
                sortable: false,
                filter: false,
                floatingFilter: false,
                floatingFilterComponent: CustomCampaignFloatingFilter,
                suppressFloatingFilterButton: false,
                hide: true,
                valueFormatter: (params) => {
                    if (!params.value) {
                        return ""; // Return an empty string if no value
                    }
                    if (Array.isArray(params.value)) {
                        return params.value.join(", "); // Join array elements with a comma
                    }
                    return params.value.toString(); // Convert to string if it's a single value
                },
            },
        ]
    },
    {
        headerName: "TAXONOMY COMPLIANCE",
        field: "actions",
        minWidth: 225,
        sortable: false,
        filter: false,
        flex: 4,
        floatingFilter: false,
        suppressHeaderMenuButton: true,
    }
];